import styles from "./Logo.module.scss";

// import logo from "assets/images/easyboosted_logo_transparent.png";
import logo from "assets/images/new/more-loads_white_v2.png"
import classnames from "classnames";
import { useSelector } from "react-redux";

const LogoDefault = ({ className }) => {
  return (
    <div className={classnames(styles.wrapper, styles.img, className)}>
      <img src={logo} alt="logo" />
    </div>
  );
};

export default LogoDefault;

export const Logo = ({ className }) => {
  const logoUrl = useSelector((state) => state.customization.logo_url);

  return (
    <div className={classnames(styles.wrapper, className)}>
      <img src={logoUrl} alt="logo" />
    </div>
  );
};

export const SmallLogo = ({ className }) => {
  const smallLogoUrl = useSelector((state) => state.customization.small_logo_url);

  return (
    <div className={classnames(styles.wrapper, className)}>
      <img src={smallLogoUrl} alt="logoIcon" />
    </div>
  );
};
